/**
 * Token store backed by localStorage.
 *
 * Tokens are persisted to localStorage so the session survives page reloads.
 * The ideal long-term solution is httpOnly cookies (immune to XSS); this is a
 * pragmatic approach for the current development stage.
 */

const ACCESS_KEY = 'ac_access_token';
const REFRESH_KEY = 'ac_refresh_token';

// In-memory cache — avoids repeated localStorage reads on every request
let accessToken: string | null = localStorage.getItem(ACCESS_KEY);
let refreshToken: string | null = localStorage.getItem(REFRESH_KEY);

export function getAccessToken(): string | null {
  return accessToken;
}

export function getRefreshToken(): string | null {
  return refreshToken;
}

export function setTokens(access: string, refresh: string): void {
  accessToken = access;
  refreshToken = refresh;
  localStorage.setItem(ACCESS_KEY, access);
  localStorage.setItem(REFRESH_KEY, refresh);
}

export function clearTokens(): void {
  accessToken = null;
  refreshToken = null;
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}
